import { gql } from "@apollo/client";

export const GET_MINUTA_PERIODO_ACTIVO = gql`
    query GetPeriodoMinutaActivo {
    periodoMinutaActivo {
      mes,
      ano,
      ano,
      fechaDesde,
      fechaHasta
    }
  }
`;

export const adaptMinutaPeriodoActivo = (periodo) => {
    return {
        mes: periodo?.mes,
        anio: periodo?.ano,
        fechaDesde: periodo?.fechaDesde,
        fechaHasta: periodo?.fechaHasta
    }
}